<template>
    <v-dialog v-model="dialog" persistent max-width="590px">
        <v-card fluid class="card-container font-theme">
            <v-card-title class="tab-header">
                <v-row no-gutters align="center">
                    <v-col class="pa-0">
                        <v-icon color="#FFF9C4" size="32">
                            mdi-information-variant-circle-outline
                        </v-icon>
                        <b class="ml-1 text-center font-theme text-header"> อัปโหลดไฟล์ </b>
                    </v-col>
                    <v-col cols="auto" sm="auto" md="auto" class="pa-0">
                        <v-btn depressed icon color="#000" @click="closeModal()">
                            <v-icon size="32"> mdi-close </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-actions class="justify-center pb-6">
                <v-form ref="validForm" lazy-validation>
                    <v-row class="d-flex align-center upload-wrapper" no-gutters>
                        <v-col cols="auto" class="pr-4">
                            <img src="../assets/excel.png" alt="Excel Icon" width="48" class="excel-icon" />
                        </v-col>
                        <v-col>
                            <v-file-input v-model="file" accept=".xlsx, .xls"
                                placeholder="กรุณาเลือกไฟล์ Excel เท่านั้น" prepend-icon="" truncate-length="30"
                                color="primary" clearable :rules="[(v) => !!v || 'กรุณาอัปโหลดไฟล์!']" required
                                class="upload-input" variant="outlined" append-icon="mdi-upload" density="comfortable"></v-file-input>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-actions>

            <v-card-actions class="pb-4">
                <v-row justify="center">
                    <v-btn rounded @click="submitForm()" color="#0B68D6"
                        class="elevation-0 font-theme confirm-btn white--text ml-1" style="width: 100px; height: 35px;">
                        ยืนยัน
                    </v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { EventBus } from '../EventBus'
export default {
    data: () => ({
        dialog: false,
        file: null
    }),
    mounted() {
        EventBus.$on('addFileExcelEvalVendor', this.openDialog)
    },
    beforeDestroy() {
        EventBus.$off('addFileExcelEvalVendor')
    },
    computed: {
        raDetail() {
            return this.$store.state.raDetail
        },
        selectedBiz() {
                return this.$store.state.confirmSelectedBiz
        },
    },
    methods: {
        openDialog() {
            this.dialog = true;
        },
       async submitForm() {
            const isValid = this.$refs.validForm.validate();
            if (isValid) {
                    try {
                        const formData = new FormData()
                            formData.append('file', this.file)
                            formData.append('tax_id', this.selectedBiz.tax_id)
                            const { data } = await this.axios.post(
                            `${this.$api_url}/import_data/api/v1/import_excel`,
                            formData,
                            {
                                headers: {
                                'Content-Type': 'multipart/form-data',
                                },
                            }
                            )
                    if (data.status) {
                        EventBus.$emit('offDialog')
                        this.closeModal();
                        this.alert('เพิ่มข้อมูลสำเร็จ', 'Success', 'success')
                        location.reload();
                        
                    } else {
                        this.alert('เพิ่มข้อมูลไม่สำเร็จ', 'Fail', 'error')
                    }
                } catch (error) {
                    this.alert('เพิ่มข้อมูลไม่สำเร็จ', 'Fail', 'error')
                    console.log(error);
                }
            }
        },
        closeModal() {
            this.$refs.validForm.reset();
            this.file = null;
            this.dialog = false;
        },
        alert(title = '', text = 'Warning', icon = 'info') {
                this.$swal({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    icon: icon,
                    title: `<b class="alert-success-title">${title}</b>`,
                    text:  text,
                    showClass: {
                        popup: 'animate-show-card'
                    },
                    customClass: {
                        container: 'alert-card-block',
                        popup: 'alert-card-success',
                        title: 'alert-title-block',
                        htmlContainer: 'alert-text-box',
                        icon: 'alert-icon'
                    }
                })
            }
    }
}
</script>
<style>
.card-container {
    padding: 10px;
    border-radius: 20px !important;
}

.tab-header {
    padding: 8px 12px !important;
}

.text-header {
    color: #000;
}

.upload-wrapper {
    border-radius: 16px;
    padding: 20px 24px;
    box-shadow: 0 6px 20px rgba(60, 86, 147, 0.1);
    max-width: 520px;
    width: 100%;
    height: 150;
}

.excel-icon {
    border-radius: 10px;
    background: #ffffff;
    padding: 6px;
    box-shadow: 0 3px 8px rgba(60, 86, 147, 0.15);
}
</style>